import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../context/I18nContext";
import { resolveImageUrl } from "./ImageUploader";

const MAX_HOME = 5;

export function References({ items = [] }) {
  const { t } = useI18n();
  const active = items.filter(r => r.active !== false);
  const visible = active.slice(0, MAX_HOME);
  const hasMore = active.length > MAX_HOME;

  const cols = Math.min(5, Math.max(2, visible.length));
  const gridClass = {
    2: "grid-cols-2",
    3: "grid-cols-2 sm:grid-cols-3",
    4: "grid-cols-2 sm:grid-cols-4",
    5: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5",
  }[cols] || "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5";

  return (
    <section
      id="references"
      data-testid="references-section"
      className="py-20 lg:py-28 bg-[#f6f6f6] relative"
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-12">
          <div className="lg:col-span-8">
            <div data-reveal className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#0d1b2a]/60">
              {t.references.eyebrow}
            </div>
            <h2
              data-reveal
              className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0d1b2a]"
              style={{ fontFamily: "Chivo, Inter, sans-serif" }}
              data-testid="references-heading"
            >
              {t.references.heading}
            </h2>
          </div>
          <p data-reveal className="lg:col-span-4 text-base text-[#0d1b2a]/70 leading-relaxed">
            {t.references.sub}
          </p>
        </div>

        {active.length === 0 ? (
          <div className="p-12 text-center text-[#0d1b2a]/40 bg-white border border-[#0d1b2a]/10 rounded-xl text-sm">
            Henüz referans eklenmedi.
          </div>
        ) : (
          <>
            <div className={`grid ${gridClass} gap-px bg-[#0d1b2a]/10 border border-[#0d1b2a]/10 rounded-xl overflow-hidden`}>
              {visible.map((r, i) => (
                <div
                  key={r.id || i}
                  data-testid={`reference-${i}`}
                  className="aspect-[4/3] bg-white p-6 flex items-center justify-center group hover:bg-[#0d1b2a] transition-colors duration-300 cursor-default"
                >
                  {r.logo_url ? (
                    <img
                      src={resolveImageUrl(r.logo_url)}
                      alt={r.name}
                      className="h-auto w-[70%] max-h-[70%] object-contain grayscale group-hover:grayscale-0 opacity-70 group-hover:opacity-100 transition-all duration-300"
                    />
                  ) : (
                    <div
                      className="text-[#0d1b2a] group-hover:text-[#ffb703] font-bold text-sm text-center transition-colors leading-tight"
                      style={{ fontFamily: "Chivo, Inter, sans-serif" }}
                    >
                      {r.name}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Tüm referanslar butonu — her zaman göster */}
            <div className="mt-8 flex justify-end">
              <Link
                to="/referanslar"
                className="inline-flex items-center gap-2 text-sm font-bold text-[#0d1b2a] border-2 border-[#0d1b2a]/20 hover:border-[#ffb703] hover:text-[#ffb703] px-5 py-2.5 rounded-md transition-all"
              >
                Tüm Referanslar
                <ArrowRight size={16} />
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
